
import _ from 'lodash';
import StatusColumn from './status-column.vue';
import TableList from '@/components/TableList/index.vue';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { interactiveChannelList } from '@com/utils/channel';
import { bizScenario, customerTypeList, exchangeCreationTypes } from '@/common/demand';
import { allNonInteractiveChannelList } from '@/views/demand/utils/creation';
import { playTurboHostList } from '@/config/host';
import { NODE_ENV } from '@com/config/env';
import { playsmartEntry } from '@pt/config';

export default {
  components: {
    TableList: TableList
  },

  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    columnConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    handleSelectionChange: {
      type: Function,
      default: function _default() {}
    },

    handleSortChange: {
      type: Function,
      default: function _default() {}
    },

    spanMethod: {
      type: Function,
      default: function _default() {}
    },

    showSort: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      tableColumnConfig: [{
        label: '选择',
        prop: 'selection',
        type: 'selection',
        flxed: 'left'
      }, {
        label: 'ID',
        prop: 'id',
        width: 70,
        sortable: 'custom'
      }, {
        prop: 'creation-cell',
        slot: 'creation-cell'
      }, {
        prop: 'cancle-cell',
        slot: 'cancle-cell'
      }, {
        prop: 'estimated-cell',
        slot: 'estimated-cell'
      }, {
        label: '需求名称',
        prop: 'name',
        type: 'link',
        params: {
          tips: function tips(_ref) {
            var row = _ref.row;

            return row.instruction;
          },
          link: function link(_ref2) {
            var row = _ref2.row;

            return '/butler/demand-detail/' + row.id;
          }
        }
      }, {
        label: '产品名称',
        prop: 'app_names'
      }, {
        label: '包名',
        prop: 'package_name',
        width: 150,
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            var packageNameArray = [];
            if (row && row.app && (row.app.android_package || row.app.ios_package)) {
              row.app.android_package && packageNameArray.push(row.app.android_package);
              row.app.ios_package && packageNameArray.push(row.app.ios_package);
            }
            return packageNameArray.join(', ');
          }
        }
      }, {
        label: 'app tag',
        prop: 'app_tag',
        slot: 'app_tag'
      }, {
        label: 'project tag',
        prop: 'project_tag',
        slot: 'project_tag'
      }, {
        label: '需求说明',
        prop: 'instruction',
        params: {
          maxLength: 25
        }
      }, {
        label: '创意标签',
        prop: 'tag_names',
        params: {
          maxLength: 25
        }
      }, {
        label: '特征标签',
        prop: 'material_tag_names',
        slot: 'material-tag-cell'
      }, {
        label: 'Size',
        prop: 'attachment_size',
        type: 'filesize'
      }, {
        label: '需求评级',
        prop: 'difficulty'
      }, {
        label: '关联需求',
        prop: 'demand_name',
        type: 'link',
        params: {
          link: function link(_ref4) {
            var row = _ref4.row;

            return '/butler/demand-detail/' + row.demand_id;
          }
        }
      }, {
        label: '创意类型',
        prop: 'creation_types',
        params: {
          innerText: function innerText(_ref5) {
            var row = _ref5.row;

            return exchangeCreationTypes(row.creation_types) || '-';
          }
        }
      }, {
        label: '业务场景',
        prop: 'biz_scenario',
        params: {
          innerText: function innerText(_ref6) {
            var row = _ref6.row;

            var bizScenarios = (bizScenario.find(function (item) {
              return Number(item.value) === Number(row.biz_scenario);
            }) || {}).label;
            return bizScenarios || '-';
          }
        }
      }, {
        label: '投放平台',
        prop: 'platforms'
      }, {
        label: '投放渠道/语言',
        prop: 'channels',
        width: 100,
        params: {
          innerHTML: function innerHTML(_ref7) {
            var row = _ref7.row;

            if (row && row.creation_tasks && row.creation_tasks.length) {
              return row.creation_tasks.map(function (task) {
                var channels = task.channel_ids.split(',');
                return channels.map(function (channel) {
                  // 因为交互素材中头条得显示巨量引擎，所以，如果是交互类型，则从 ineractiveChannelList 中拿 label 值
                  return useValueExchangeLabel(Number(channel), row.type === 1 ? interactiveChannelList : allNonInteractiveChannelList());
                }).join() + ': ' + task.languages;
              }).reduce(function (accumulator, currentValue) {
                return accumulator + '<div>' + currentValue + '</div>';
              }, '');
            }
            return '-';
          }
        }
      },
      // 创意报表使用
      {
        label: '投放渠道/语言',
        prop: 'channel',
        width: 100,
        params: {
          innerText: function innerText(_ref8) {
            var row = _ref8.row;

            if (row && row.channel) {
              return row.channel + ': ' + row.languages;
            }
            return '-';
          }
        }
      }, {
        label: '是否KA',
        prop: 'key_account',
        params: {
          innerText: function innerText(_ref9) {
            var row = _ref9.row;

            return useValueExchangeLabel(row.key_account, customerTypeList);
          }
        }
      }, {
        label: '我的优先级',
        prop: 'priority'
      }, {
        label: '状态',
        prop: 'status',
        component: StatusColumn
      }, {
        prop: 'staff-cell',
        slot: 'staff-cell'
      }, {
        label: '提需人',
        prop: 'demander_name'
      }, {
        label: 'AM',
        prop: 'account_manager_name'
      }, {
        label: '策划师',
        prop: 'planner_name'
      }, {
        label: '设计师',
        prop: 'designer_name',
        params: {
          innerText: function innerText(_ref10) {
            var row = _ref10.row;

            if (row && row.designer_name && row.status !== 'submited' && row.status !== 'rejected') {
              return row.designer_name;
            }
            return '-';
          }
        }
      }, {
        label: '广告主',
        prop: 'adv_name'
      }, {
        label: '提需日期',
        prop: 'submit_time',
        width: 100,
        sortable: 'custom'
      }, {
        label: '期望完成日期',
        prop: 'expect_time',
        width: 120,
        sortable: 'custom'
      }, {
        label: '工时消耗',
        prop: 'worktime'
      }, {
        label: '实际完成日期',
        prop: 'deliver_time',
        width: 120,
        sortable: 'custom'
      }, {
        label: '开始时间',
        prop: 'start_date'
      }, {
        label: '结束时间',
        prop: 'end_date'
      }, {
        label: '计划完成日期（新）',
        prop: 'newday'
      }, {
        label: '创意名称',
        prop: 'creation_name'
      }, {
        label: '创意标签',
        prop: 'tag_ids'
      }, {
        label: '创意标签',
        prop: 'tags',
        params: {
          maxLength: 25
        }
      }, {
        label: 'Dimension',
        prop: 'creation_size'
      }, {
        label: 'impression',
        prop: 'impression'
      }, {
        label: 'click',
        prop: 'clicks'
      }, {
        label: 'install',
        prop: 'install'
      }, {
        label: 'Spend',
        prop: 'spend'
      }, {
        label: 'CPI',
        prop: 'cpi'
      }, {
        label: 'CTR',
        prop: 'ctr'
      }, {
        label: 'CVR',
        prop: 'cvr'
      }, {
        label: 'IVR',
        prop: 'ivr'
      }, {
        label: 'ROI',
        prop: 'roi'
      }, {
        label: 'eCPC',
        prop: 'ecpc'
      }, {
        label: 'eCPM',
        prop: 'ecpm'
      }, {
        label: '研发',
        prop: 'developer_name'
      }, {
        label: '关联测试任务',
        prop: 'total_tasks',
        width: 100,
        params: {
          innerHTML: function innerHTML(_ref11) {
            var row = _ref11.row;

            if (row && row.total_tasks) {
              return '<a href="#/butler/task-list?keyword=' + row.id + '&search_field=demand_id">' + row.done_tasks + '</a> / ' + row.total_tasks;
            }
            return row.total_tasks;
          }
        }
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }, {
        label: '需求类型',
        prop: 'type'
      }, {
        label: '下单日期',
        prop: 'order_time',
        type: 'time',
        width: 120,
        params: {
          format: '{y}-{m}-{d}'
        }
      }, {
        label: '参考需求',
        prop: 'similar_demand_ids'
      }, {
        prop: 'bind_project_id',
        slot: 'bind-project-id'
      }]
    };
  },


  computed: {
    tableConfig: function tableConfig() {
      var config = {};
      if (this.$route.query && this.$route.query.order) {
        config = {
          'default-sort': {
            prop: this.$route.query.order.replace('-', ''),
            order: this.$route.query.order.indexOf('-') !== -1 ? 'descending' : 'ascending'
          }
        };
      } else {
        config = {};
      }
      return config;
    },
    innerList: function innerList() {
      if (_.isArray(this.list)) {
        return this.list.map(function (item) {
          item.worktime = '-';
          if (item.work_days) {
            item.worktime = item.work_days + 'd';
          }
          if (item.work_hours) {
            item.worktime = item.work_hours + 'h';
          }
          return item;
        });
      }
      return [];
    },


    // 过滤表数据
    filterColumnConfig: function filterColumnConfig() {
      var _this = this;

      var tempConfig = [];
      this.columnConfig.map(function (columnProp) {
        _this.tableColumnConfig.map(function (item) {
          if (columnProp && item.prop === columnProp) {
            if (!_this.showSort && item.sortable) {
              item.sortable = false;
            }
            tempConfig.push(item);
          }
        });
      });

      return tempConfig;
    },
    playTurboUrl: function playTurboUrl() {
      return '' + playTurboHostList[NODE_ENV];
    }
  },

  methods: {
    parseTag: function parseTag(row) {
      if (row && row.material_tag_names) {
        return JSON.parse(row.material_tag_names);
      }
      return {};
    },
    jumpToBindProject: function jumpToBindProject(row) {
      console.log(row);
      var newTab = window.open('about:blank');
      var close = function close() {
        if (newTab) {
          newTab.close();
          newTab = null;
        }
      };
      try {
        if (row.bind_project_source === 'ps') {
          newTab.location.href = '' + this.playTurboUrl + playsmartEntry + '#/workbench?id=' + row.bind_project_id;
          newTab = null;
        } else if (row.bind_project_source === 'gm') {
          newTab.location.href = this.playTurboUrl + '/#/my-project/playable/' + row.bind_project_tpl_id + '/custom/' + row.bind_project_id;
          newTab = null;
        } else {
          close();
        }
      } catch (err) {
        close();
      }
    }
  }
};